<!--
  Vue wrapper for Bryntum ProjectModel
-->

<template>

</template>

<script>

import { AssignmentModel, AssignmentStore, DependencyModel, DependencyStore, EventModel, EventStore, Model, ProjectModel, ResourceModel, ResourceStore, ResourceTimeRangeModel, ResourceTimeRangeStore, StateTrackingManager, Store, TimeRangeModel, TimeSpan } from '@bryntum/scheduler';

import { StringHelper } from '@bryntum/scheduler';
import WrapperHelper from './WrapperHelper.js';
import WrapperHelperVue2 from './WrapperHelperVue2.js';

export default {

    // eslint-disable-next-line vue/multi-word-component-names
    name : 'BryntumProjectModel',

    props : {

         // Configs only
        adjustDurationToDST         : { type : Boolean, default : undefined },
        assignmentModelClass        : { type : Function, default : undefined },
        assignmentsData             : { type : Array, default : undefined },
        assignmentStoreClass        : { type : Function, default : undefined },
        children                    : { type : [Boolean, Array], default : undefined },
        dependenciesData            : { type : Array, default : undefined },
        dependencyModelClass        : { type : Function, default : undefined },
        dependencyStoreClass        : { type : Function, default : undefined },
        eventModelClass             : { type : Function, default : undefined },
        eventsData                  : { type : Array, default : undefined },
        eventStoreClass             : { type : Function, default : undefined },
        expanded                    : { type : Boolean, default : undefined },
        orderedParentIndex          : { type : Number, default : undefined },
        parentId                    : { type : [String, Number, null], default : undefined },
        parentIndex                 : { type : Number, default : undefined },
        resourceModelClass          : { type : Function, default : undefined },
        resourcesData               : { type : Array, default : undefined },
        resourceStoreClass          : { type : Function, default : undefined },
        resourceTimeRangesData      : { type : Array, default : undefined },
        resourceTimeRangeStoreClass : { type : Function, default : undefined },
        silenceInitialCommit        : { type : Boolean, default : undefined },
        timeRangesData              : { type : Array, default : undefined },
        timeRangeStoreClass         : { type : Function, default : undefined },

         // Configs and properties
        assignments            : { type : Array, default : undefined },
        assignmentStore        : { type : [AssignmentStore, Object], default : undefined },
        dependencies           : { type : Array, default : undefined },
        dependencyStore        : { type : [DependencyStore, Object], default : undefined },
        events                 : { type : Array, default : undefined },
        eventStore             : { type : [EventStore, Object], default : undefined },
        id                     : { type : [String, Number], default : undefined },
        json                   : { type : String, default : undefined },
        readOnly               : { type : Boolean, default : undefined },
        resources              : { type : Array, default : undefined },
        resourceStore          : { type : [ResourceStore, Object], default : undefined },
        resourceTimeRanges     : { type : Array, default : undefined },
        resourceTimeRangeStore : { type : [ResourceTimeRangeStore, Object], default : undefined },
        stm                    : { type : [StateTrackingManager, Object], default : undefined },
        timeRanges             : { type : Array, default : undefined },
        timeRangeStore         : { type : [Store, Object], default : undefined },
        timeZone               : { type : [String, Number], default : undefined },

         // Properties only
        allChildren                : { type : Array, default : undefined },
        autoExposeFields           : { type : Boolean, default : undefined },
        childrenField              : { type : String, default : undefined },
        convertEmptyParentToLeaf   : { type : [Boolean, Object], default : undefined },
        defaults                   : { type : Object, default : undefined },
        descendantCount            : { type : Number, default : undefined },
        hasGeneratedId             : { type : Boolean, default : undefined },
        idField                    : { type : String, default : undefined },
        inlineData                 : { type : Object, default : undefined },
        internalId                 : { type : Number, default : undefined },
        isCommitting               : { type : Boolean, default : undefined },
        isCreating                 : { type : Boolean, default : undefined },
        isValid                    : { type : Boolean, default : undefined },
        previousSiblingsTotalCount : { type : Number, default : undefined },
        relations                  : { type : Object, default : undefined },
        visibleDescendantCount     : { type : Number, default : undefined },

         // Events
        onChange    : { type : Function },
        onDataReady : { type : Function },

    },

    data : () => {
        return {
            instanceClass : ProjectModel,
            instanceName : 'ProjectModel',

            configNames : [
                'adjustDurationToDST',
                'assignmentModelClass',
                'assignmentsData',
                'assignmentStoreClass',
                'children',
                'dependenciesData',
                'dependencyModelClass',
                'dependencyStoreClass',
                'eventModelClass',
                'eventsData',
                'eventStoreClass',
                'expanded',
                'orderedParentIndex',
                'parentId',
                'parentIndex',
                'resourceModelClass',
                'resourcesData',
                'resourceStoreClass',
                'resourceTimeRangesData',
                'resourceTimeRangeStoreClass',
                'silenceInitialCommit',
                'timeRangesData',
                'timeRangeStoreClass'
            ],

            propertyConfigNames : [
                'assignments',
                'assignmentStore',
                'dependencies',
                'dependencyStore',
                'events',
                'eventStore',
                'id',
                'json',
                'onChange',
                'onDataReady',
                'readOnly',
                'resources',
                'resourceStore',
                'resourceTimeRanges',
                'resourceTimeRangeStore',
                'stm',
                'timeRanges',
                'timeRangeStore',
                'timeZone'
            ],

            propertyNames : [
                'allChildren',
                'autoExposeFields',
                'childrenField',
                'convertEmptyParentToLeaf',
                'defaults',
                'descendantCount',
                'hasGeneratedId',
                'idField',
                'inlineData',
                'internalId',
                'isCommitting',
                'isCreating',
                'isValid',
                'previousSiblingsTotalCount',
                'relations',
                'visibleDescendantCount'
            ],

            eventNames : [
                'change',
                'dataReady'
            ]
        };
    },

    /**
     * Called after the instance has been mounted
     */
    mounted() {
        const
            me = this,
            {
                createWidget,
                relayStores,
                watchProps
            }  = WrapperHelper(),
            {
                processCellContent,
                hasFrameworkRenderer
            }  = WrapperHelperVue2();

        me.instance = createWidget({
            me,
            props     : me.$props,
            data      : me.$data,
            listeners : me.$listeners,
            emit      : me.$emit.bind(me),
            element   : me.$el
        });

        const watcher = me.$watch.bind(me);
        watchProps(me, me.instance, me.$props, me.$data, watcher);
    },

    /**
     * Called right before a Vue instance is destroyed. At this stage the instance is still fully functional.
     */
    beforeDestroy() {
        if (this.instance) {
            this.instance.destroy();
        }
    }

};

</script>
